<script>
	/**
	 * @author M.G.
	 */
	import {onDestroy, onMount} from "svelte";
	import {External} from "../external";

	export let input, name, value, placeholder = "", onChange;

	let phoneInput;
	const initValue = value || '';
	let changeTimer;

	let triggerChange = (value) => {
		if (!onChange) {
			return;
		}

		if (changeTimer) {
			clearTimeout(changeTimer);
		}

		changeTimer = setTimeout(() => {
			onChange(value);
		}, 500);
	}

	onMount(() => {
		phoneInput = External.PhoneInput.wrap(input, (number) => {
			// when the phone is wrapped, and the value is without the country code (i.e. legacy phone numbers)
			// the PhoneInput component will change it to the proper format (with a country code)
			// i.e. "(255) 444-555" becomes "+1 (255) 444-555". Which will fire the onChange event immediately on mount...
			// which can break the UI - for example, the Order Details screen will show as "changed" on load without the customer
			// actually changing anything.
			if (value !== '' && number.endsWith(value) && number.startsWith("+") && !value.startsWith("+")) {
				return;
			}

			// phone didn't change
			if (number === value) {
				return;
			}

			value = number;
			triggerChange(value);
		}, true);
	});

	onDestroy(() => {
		phoneInput.destroy();
	});

</script>

<input class="admin-phone-input" bind:this={input} type="text" {name} value={initValue} {placeholder}/>
